module.exports = "<ul class=\"wizard-nav--list\">\n  <ng-content></ng-content>\n</ul>\n"